import { ENV_IDENTIFIER } from './constants';

const env = process.env.ENV;
const THIRD_SERVICE_CONFIG = {
  [ENV_IDENTIFIER.DEV]: {
    amap: {
      securityJsCode: '3af0dcaddec63ae885cd7db07a4aca09',
      key: '088ad716a847a31b5e76945c51995b7a',
    },
  },
  [ENV_IDENTIFIER.TEST]: {
    amap: {
      securityJsCode: '3af0dcaddec63ae885cd7db07a4aca09',
      key: '088ad716a847a31b5e76945c51995b7a',
    },
  },
  [ENV_IDENTIFIER.OLD_PRE]: {
    amap: {
      securityJsCode: '3af0dcaddec63ae885cd7db07a4aca09',
      key: '088ad716a847a31b5e76945c51995b7a',
    },
  },
  [ENV_IDENTIFIER.PRE]: {
    amap: {
      securityJsCode: '3af0dcaddec63ae885cd7db07a4aca09',
      key: '088ad716a847a31b5e76945c51995b7a',
    },
  },
  [ENV_IDENTIFIER.PRODUCT]: {
    amap: {
      securityJsCode: '3af0dcaddec63ae885cd7db07a4aca09',
      key: '088ad716a847a31b5e76945c51995b7a',
    },
  },
};

export const THIRD_SERVICE: any = THIRD_SERVICE_CONFIG[env || ENV_IDENTIFIER.PRODUCT] || {};
